export default __webpack_public_path__ + "static/media/vuesax-linear-key.8ce5e251.svg";